import React from 'react';

interface ForecastLineChartXAxisTickProps {
  x?: number;
  y?: number;
  payload?: {
    value: string;
  };
}

const ForecastLineChartXAxisTick: React.FC<ForecastLineChartXAxisTickProps> = ({
  x,
  y,
  payload,
}) => {
  const [yearMonth, time] = (payload?.value ?? '').split(' ');
  return (
    <g transform={`translate(${x},${y})`}>
      <text className="pop-11-normal fill-dark-10" y="15" textAnchor="middle">
        {yearMonth}
      </text>
      <text className="pop-11-semibold fill-dark-10" y="28" textAnchor="middle">
        {time}
      </text>
    </g>
  );
};

export default ForecastLineChartXAxisTick;
